import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import Viewer2 from './components/Viewer2';
import styles from '../../styles/components/CanvasEditor.scss';
import Toolbar from './components/Toolbar/Toolbar';

function CanvasEditor({
  onSubmit,
  annotations,
  pinnedTasks,
  children,
  source,
  sourceType,
  disabled,
  onViewerReady,
  onFabricOverlayReady,
}) {
  return (
    <div className={styles.wrapper}>
      <Viewer2
        source={source}
        onSubmit={onSubmit}
        disabled={disabled}
        onViewerReady={onViewerReady}
        onFabricOverlayReady={onFabricOverlayReady}
        annotations={annotations}
        pinnedTasks={pinnedTasks || []}
        sourceType={sourceType}
      />

      {(source?.download_url || sourceType == 'plan') && !disabled && (
        <div id='toolbar'>
          <Toolbar
            onSubmit={onSubmit}
            source={source}
            sourceType={sourceType}
          />
        </div>
      )}

      {children}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    canvas_editor: state.canvas_editor,
  };
};

export default withRouter(connect(mapStateToProps, null)(CanvasEditor));
